<template>
  <v-card class="pa-2" minWidth="150">
    <v-layout justify-end>
      <!-- <v-spacer></v-spacer> -->
      <!-- <v-flex> -->
      <v-icon
        class="pl-1 icon-close"
        small
        color="white"
        @click="$emit('closeBubble')"
      >
        clear
      </v-icon>
      <!-- </v-flex> -->
    </v-layout>
    <v-flex class="caption grey--text" pl-4>{{ info.zone }}</v-flex>
    <v-flex d-inline-flex>
      <v-icon class="pl-1" small :color="info.color">lens</v-icon>
      <v-flex class="body-2" pl-1>{{ info.name }}</v-flex>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: 'info-bubble-polygon-name',
  props: {
    info: Object
  },
  watch: {
    info(newValue, oldValue) {
      console.log('WATCH info', newValue, oldValue)
    }
  }
}
</script>

<style lang="stylus" scoped>
.icon-close {
  margin-bottom: -15px;
  cursor: pointer;
}

.icon-close:hover {
  opacity: 0.75;
}
</style>


// WEBPACK FOOTER //
// src/components/InfoBubblePolygonName.vue